import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CashInService from '../../../services/Celcoin/immediateCashInService';
import { getTranslations } from '../../../services/languageUtils';

const BillShow = () => {
  const [translations, setTranslations] = useState({});
  const [items, setItems] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations(localStorage.getItem('language') || 'pt');
      setTranslations(trans);
    };
    loadTranslations();
  }, []);

  const formatToBRL = (value) =>
    value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const openInNewTab = (url) => {
    window.open(url, '_blank');
  };

  const fetchBills = async (currentPage = 1) => {
  if (!startDate || !endDate) {
    return toast('Selecione as datas de início e fim', {
      position: 'top-right',
      autoClose: 3000,
      type: 'error',
    });
  }

  setLoading(true);
    try {
      const start = (currentPage - 1) * pageSize;

      const res = await CashInService.show({
        startDate: `${startDate}T00:00:00-03:00`,
        endDate: `${endDate}T23:59:59-03:00`,
        start,
      });

      const filteredItems = (res.data.items || []).filter(
        item => item.payable_with !== 'pix'
      );

      setItems(filteredItems);

      const totalFiltrado = filteredItems.length;
      setTotalItems(totalFiltrado);

      setPage(currentPage);
    } catch (err) {
      console.error(err);
      toast('Erro ao buscar boletos', {
        position: 'top-right',
        autoClose: 3000,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(totalItems / pageSize) || 1;

  const handlePrevPage = () => {
    if (page > 1) fetchBills(page - 1);
  };

  const handleNextPage = () => {
    if (page < totalPages) fetchBills(page + 1);
  };

  return (
    <section className="TableContent" id="ComponentTable" style={{ padding: '20px' }}>
      <h3 style={{ marginBottom: '15px' }}>
        {translations?.billList || 'Listagem de Boletos'}
      </h3>

      <div
        style={{
          marginBottom: '20px',
          display: 'flex',
          gap: '10px',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <div>
          <label>Data inicial: </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div>
          <label>Data final: </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

        <button
          onClick={() => fetchBills(1)}
          disabled={loading}
          style={{
            backgroundColor: '#1c787e',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '8px 16px',
            cursor: 'pointer',
          }}
        >
          {loading ? 'Buscando...' : 'Pesquisar'}
        </button>
      </div>

      {items.length > 0 ? (
        <>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '14px',
            }}
          >
            <thead>
              <tr>
                <th style={{ borderRadius: '8px 0 0 8px', padding: '8px' }}>Status</th>
                <th>Valor</th>
                <th>Pagador</th>
                <th>Linha digitável</th>
                <th>Vencimento</th>
                <th style={{ borderRadius: '0 8px 8px 0' }}>Ação</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>{item.status}</td>
                  <td>{formatToBRL(item.total_cents / 100)}</td>
                  <td>{item.payer_name || '-'}</td>
                  <td>
                    <b>{item.bank_slip?.digitable_line || '-'}</b>
                  </td>
                  <td>{item.due_date}</td>
                  <td
                    style={{ cursor: 'pointer', textAlign: 'center' }}
                    onClick={() => openInNewTab(item.bank_slip?.bank_slip_pdf_url)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#1c787e"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* 🔹 Paginação */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              marginTop: '20px',
            }}
          >
            <button
              onClick={handlePrevPage}
              disabled={page === 1 || loading}
              style={{
                backgroundColor: '#ccc',
                border: 'none',
                borderRadius: '4px',
                padding: '6px 12px',
                cursor: page === 1 ? 'not-allowed' : 'pointer',
              }}
            >
              Anterior
            </button>

            <span>
              Página {page} de {totalPages}
            </span>

            <button
              onClick={handleNextPage}
              disabled={page === totalPages || loading}
              style={{
                backgroundColor: '#ccc',
                border: 'none',
                borderRadius: '4px',
                padding: '6px 12px',
                cursor: page === totalPages ? 'not-allowed' : 'pointer',
              }}
            >
              Próxima
            </button>
          </div>
        </>
      ) : (
        !loading && <p>Nenhum boleto encontrado no período selecionado.</p>
      )}

      <ToastContainer />
    </section>
  );
};

export default BillShow;
